<div class="w-[1200px]">
  <h2 class="font-semibold text-lg mb-4">{{ title$ | async }}</h2>

  <div class="flex flex-wrap gap-2 mb-2">
    <tui-input
      class="w-4/12 basis-[calc(33.333%-0.5rem)]"
      tuiTextfieldSize="m"
      [formControl]="carrierForm.controls.name"
      >Наименование</tui-input
    >
    <tui-input
      class="w-4/12 basis-[calc(33.333%-0.5rem)]"
      tuiTextfieldSize="m"
      [formControl]="carrierForm.controls.unp"
      >УНП</tui-input
    >
    <tui-input
      class="w-4/12 basis-[calc(33.333%-0.5rem)]"
      tuiTextfieldSize="m"
      [formControl]="carrierForm.controls.address"
      >Адрес</tui-input
    >
    <tui-input
      class="w-4/12 basis-[calc(33.333%-0.5rem)]"
      tuiTextfieldSize="m"
      [formControl]="carrierForm.controls.contractNumber"
      >Номер контракта</tui-input
    >
    <div class="w-2/12 basis-[calc(16.666%-0.5rem)]">
      <app-input-date
        [labelOutside]="false"
        label="Дата"
        [formControl]="carrierForm.controls.contractDate"
      ></app-input-date>
    </div>

    <div class="w-2/12 basis-[calc(25%-0.5rem)]">
      <tui-input tuiTextfieldSize="m" [formControl]="carrierForm.controls.head"
        >Руководитель</tui-input
      >
    </div>

    <div class="w-2/12 basis-[calc(25%-0.5rem)]">
      <tui-input tuiTextfieldSize="m" [formControl]="carrierForm.controls.email"
        >Email</tui-input
      >
    </div>

    <tui-input
      class="w-full basis-[calc(100%-0.5rem)]"
      tuiTextfieldSize="m"
      [formControl]="carrierForm.controls.comment"
    >
      Комментарий</tui-input
    >
  </div>
  <h3 class="font-semibold mb-2">Контакты логистов</h3>
  <div class="mb-2 max-h-[300px] overflow-y-scroll hide-scrollbar">
    @for (
      address of carrierForm.controls.logisticiansJson.controls;
      track index;
      let last = $last;
      let index = $index
    ) {
      <div class="flex gap-x-2 items-center mb-2">
        <tui-input
          class="w-6/12"
          tuiTextfieldSize="m"
          [tuiTextfieldLabelOutside]="false"
          [formControl]="address.controls.name"
          >Имя
        </tui-input>
        <tui-input
          [maskito]="phoneMask"
          class="w-6/12"
          tuiTextfieldSize="m"
          [tuiTextfieldLabelOutside]="false"
          [formControl]="address.controls.phone"
          >Телефон
        </tui-input>

        <div class="flex gap-x-2 w-1/12 items-center">
          <button
            appearance="accent"
            size="s"
            (click)="removeLogistician(index)"
            tuiIconButton
            icon="tuiIconTrash"
          ></button>
          @if (last) {
            <button
              size="s"
              (click)="addLogistician()"
              tuiIconButton
              icon="tuiIconPlus"
            ></button>
          }
        </div>
      </div>
    } @empty {
      <button size="s" tuiButton icon="tuiIconPlus" (click)="addLogistician()">
        Добавить контакт
      </button>
    }
  </div>
  <div class="flex justify-end mt-4">
    <button
      (click)="context.$implicit.complete()"
      size="m"
      appearance="outline"
      tuiButton
      class="mr-2"
    >
      Отмена
    </button>
    <button
      (click)="save$.next()"
      [disabled]="!carrierForm.valid"
      tuiButton
      size="m"
    >
      Сохранить
    </button>
  </div>
</div>
